// extracted by mini-css-extract-plugin
module.exports = {"bgOverlay":"testimonial_bgOverlay__hFMqE","textShadow":"testimonial_textShadow__mR39V"};